<template>
  <div>
    <Head style="background-color: #fff"></Head>
    <navigationbar ref="navbar"></navigationbar>
    <div class="top-bg"></div>
    <div v-if="video_info" class="content">
      <div class="flex flex-direction align-center">
        <div class="top-bg"></div>
        <div class="wrap width flex flex-direction">
          <span v-if="video_info.Videos" class="font-size-24 font-color-1c"
            >正在播放：{{ video_info.Videos[playIndex].VideoTitle }}</span
          >
          <!-- 顶部视频播放器区域-->
          <div class="vd">
            <div class="vd-tp flex">
              <div
                v-if="videoFormat != 'swf'"
                class="video font-size-none"
                id="dplayer"
                style="background-color: #262930"
              ></div>
              <div
                v-else
                class="video font-size-none"
                id="dplayer"
                style="background-color: #262930"
              >
                <embed :src="playUrl" width="10.15rem" />
              </div>

              <div class="menu flex flex-direction">
                <p class="font-size-26 font-color-23c">
                  {{ video_info.CourseTitle }}
                </p>
                <p class="font-size-18 font-color-a5 margin-top-5">
                  共{{ video_info.VideosCount }}集
                </p>
                <div v-if="video_info.Videos" class="menu-item-wrap flex-sub">
                  <div
                    class="
                      menu-item
                      flex
                      justify-between
                      align-center
                      cursor-pointer
                    "
                    v-for="(item, index) in video_info.Videos"
                    :key="index"
                    @click="playVideo(index)"
                    @mousewheel="menu_scroll"
                  >
                    <img
                      class="play-icon"
                      v-if="playIndex == index"
                      src="../../assets/video/icon-video-played.png"
                    />
                    <img
                      class="play-icon"
                      v-else
                      src="../../assets/video/icon-video-play.png"
                    />
                    <p
                      :class="
                        playIndex == index ? 'font-color-23c' : 'font-color-ff'
                      "
                      class="list font-size-20 font-color-ff t-line-1 flex-sub"
                    >
                      {{ item.VideoTitle }}
                    </p>
                  </div>
                  <div
                    v-if="showShadow"
                    class="shadow"
                    @click.prevent="menu_scroll"
                  >
                    <span class="animation">︽</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="vd-bottom" v-if="video_info.Videos">
              <div class="share flex align-center justify-between">
                <div v-if="showShare" class="share-img" @click="closeShare">
                  <p class="font-color-a5 font-size-18">关闭</p>
                  <!-- <img :src="qr_image" /> -->
                  <div class="qr-code" ref="qrCodeUrl"></div>
                </div>
                <div class="flex align-center">
                  <p class="font-size-22 font-color-bd">分享到：</p>
                  <img
                    class="img wx cursor-pointer"
                    src="../../assets/video/icon-video-wx.png"
                    @click="shareWechat"
                  />

                  <img
                    class="img qq cursor-pointer"
                    src="../../assets/video/icon-video-qq.png"
                    @click="shareToQQZone"
                  />
                </div>
                <div
                  class="btn flex flex-center cursor-pointer"
                  @click="requestLike"
                >
                  <img
                    v-if="video_info.Videos[playIndex].IsLiked"
                    class="icon"
                    src="../../assets/video/icon-video-favoed.png"
                  />
                  <img
                    v-else
                    class="icon"
                    src="../../assets/video/icon-video-favo.png"
                  />
                  <p
                    v-if="video_info.Videos"
                    class="font-color-ff font-size-22"
                  >
                    {{ video_info.Videos[playIndex].LikeCount }}
                  </p>
                </div>
              </div>
              <div class="video_info">
                <p class="t font-size-22">课程简介</p>
                <p class="des font-size-20 font-color-a5">
                  {{ video_info.CourseInfo }}
                </p>
              </div>
            </div>
          </div>

          <!-- 视频底部推荐课程区域 -->
          <div class="rec">
            <div class="t flex align-center">
              <div class="top-t font-size-26 font-color-00">推荐课程</div>
            </div>
            <div class="rec-list flex align-center flex-wrap">
              <courseItem
                v-for="(item, index) in rec_list"
                :key="index"
                :item="item"
                :index="item.CourseId"
              >
              </courseItem>
            </div>
          </div>
        </div>
        <!-- <div class="bottom-bg"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import flvjs from "flv.js/dist/flv.min.js";
import DPlayer from "dplayer";
import common from "@/utils/common.js";
import QRCode from 'qrcodejs2'
window.flvjs = flvjs;

export default {
  data() {
    return {
      qrurl: '',
      Id: 0,
      cateId: 0,
      videoId: 0,
      playIndex: 0,
      playUrl: "",
      dplayer: null,
      rec_list: [],
      video_info: {},
      videoFormat: "",
      qr_image: "",
      stayTime: 0,
      stayTimer: null,
      counterTimer: null,
      showShare: false,
      showShadow: false,
      CatalogData: null,
      noplayAuthrization: false
    };
  },
  mounted() {
    // window.addEventListener("beforeunload", (e) => this.addPlayLog());
  },
  created() {
    this.prepeare();
  },
  watch: {
    $route(to, from) {
      if (
        String(this.$route.params.cateId) &&
        this.$route.params.Id &&
        this.$route.params.videoId
      ) {
        this.prepeare();
      }
    },
    playUrl() {
      if (!common.userBase.ProductIds.includes(3)) {
        this.$toast.error('暂无权限查看该视频，请在机构IP范围内使用！')
        return
      }
      if (common.userBase.UserType === 2) {
        this.$message.error('暂无权限查看该视频，请在机构IP范围内使用！')
        return
      }

      if (this.playUrl) {
        if (this.playUrl.indexOf(".mp4") > 0) {
          this.videoFormat = "auto";
        } else if (this.playUrl.indexOf(".flv") > 0) {
          this.videoFormat = "flv";
        } else if (this.playUrl.indexOf(".swf") > 0) {
          this.videoFormat = "swf";
        }
        if (this.videoFormat == "swf") {
          this.dplayer.destroy();
          this.dplayer = null;
          clearInterval(this.timer);
          this.timer = null;
          this.stayTime = 0;
          return;
        }

        var that = this;
        if (this.dplayer != null) {
          this.dplayer.destroy();
          this.dplayer = null;
          this.destroyTimer();
        }
        this.dplayer = new DPlayer({
          container: document.getElementById("dplayer"),
          autoplay: true,
          theme: "#23CEBC",
          loop: false,
          lang: "zh-cn",
          screenshot: true,
          hotkey: true,
          preload: "auto",
          contextmenu: [],
          mutex: true,
          video: {
            url: that.playUrl,
            type: that.videoFormat,
            pic: that.video_info.Videos[that.playIndex].VideoImage,
          },
        });

        this.dplayer.on("play", function () {
          that.startTimer();
          setTimeout(() => {
            that.addPlayLog();
          }, 1000);
        });
        this.dplayer.on("pause", function () {
          that.destroyTimer();
        });
        this.dplayer.on("ended", function () {
          console.log(that.dplayer.setting.loop);
          if (!that.dplayer.setting.loop) {
            that.destroyTimer();
            if (that.playIndex + 1 <= that.video_info.Videos.length) {
              // that.playIndex += 1;
              that.playVideo(that.playIndex + 1);
            }
          } else {
            that.dplayer.seek(0);
            that.dplayer.play();
          }
        });
        if (this.video_info.Videos[this.playIndex].LastPlayTime > 0) {
          let duration = this.video_info.Videos[this.playIndex].Duration;
          let playtime = this.video_info.Videos[this.playIndex].LastPlayTime;
          if (duration - playtime <= 2) {
            this.dplayer.seek(0);
          } else {
            this.dplayer.seek(
              this.video_info.Videos[this.playIndex].LastPlayTime
            );
          }
        }
        window.history.replaceState(
          "",
          "",
          this.video_info.Videos[this.playIndex].Id
        );
      } else {
        this.$toast.error('暂无权限查看该视频，请在机构IP范围内使用！')
      }
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
    this.addPlayLog();
    this.destroyTimer();
  },

  methods: {
    startTimer() {
      this.destroyTimer();
      this.counterTimer = setInterval(() => {
        this.addPlayLog();
      }, 5000);
      this.stayTimer = setInterval(() => {
        this.stayTime += 1;
      }, 1000);
    },
    destroyTimer() {
      if (this.counterTimer) {
        clearInterval(this.counterTimer);
        this.counterTimer = null;
      }
      if (this.stayTimer) {
        clearInterval(this.stayTimer);
        this.stayTimer = null;
      }
    },
    prepeare() {
      // const state = this.$route.query.secret;
      // console.log(state);
      // if (state) {
      //   this.Id = this.$route.params.Id;
      //   this.cateId = this.$route.params.cateId;
      //   this.videoId = this.$route.params.videoId;
      //   this.requestQRImage();
      //   this.requestRelated();
      //   this.request({
      //     UserId: 0,
      //     ComId: 0,
      //     secret: state,
      //   });
      //   return;
      // }
      
      var token = common.getCookie("utoken");
      if (token && token != '') {
        this.Id = this.$route.params.Id;
        this.cateId = this.$route.params.cateId;
        this.videoId = this.$route.params.videoId;
        this.requestRelated();
        this.request(common.userBase);
      } else {
        localStorage.setItem("islogin_httpurl", window.location.href);
        this.$router.replace({
          name: "index",
          params: {
            isfirst: "first",
            states: "login",
          },
        });
      }
    },
    menu_scroll() {
      if (this.showShadow) {
        this.showShadow = false;
      }
    },
    toDecimal(x) {
      var f = parseFloat(x);
      if (isNaN(f)) {
        return 0.0;
      }
      f = Math.round(x * 100) / 100;
      return f;
    },
    addPlayVideoLog() {
      if (this.dplayer && this.dplayer.video) {
        let v = this.video_info.Videos[this.playIndex];
        let params = {
          ProductId: 3,
          CatalogId: this.cateId,
          CourseId: this.Id,
          VideoId: v.Id,
          ComId: common.userBase ? common.userBase.ComId : 0,
          UserId: common.userBase ? common.userBase.UserId : 0,
          VideoName: v.VideoTitle,
          LastWatchTime: parseInt(this.dplayer.video.currentTime),
          StayTime: this.stayTime,
          StudyPercent: this.toDecimal(
            this.dplayer.video.currentTime / this.dplayer.video.duration
          ),
          ImageUrl: v.VideoImage,
        };
        console.log(params);
        this.postRequest("api/v1/Logs/PostVideoLog", params).then((res) => {
          console.log(res);
        });
      }
      
    },
    addPlayLog() {
      this.addPlayVideoLog();
      let v = this.video_info.Videos[this.playIndex];
      let params = {
        logId: `child_${new Date().getTime()}`,
        productIds: 3,
        customerCode: common.userBase ? common.userBase.ComCode : "",
        customerName: common.userBase ? common.userBase.ComName : "",
        customerId: common.userBase ? common.userBase.ComId : 0,
        userId: common.userBase ? common.userBase.UserId : 0,
        userName: common.userBase ? common.userBase.UserName : "",
        sourceType: "PC",
        catalogId: this.cateId,
        catalogData: this.CatalogData == null ? "" : this.CatalogData,
        courseId: this.Id,
        courseName: this.video_info.CourseTitle,
        videoId: v.Id,
        videoName: v.VideoTitle,
        watchDuration: this.stayTime,
        watchPoint:
          this.dplayer.video.currentTime == null
            ? 0
            : parseInt(this.dplayer.video.currentTime),
        duration:
          this.dplayer.video.duration == null
            ? 0
            : parseInt(this.dplayer.video.duration),
        actId: 0,
      };

      console.log(params);
      this.postRequestVisit("Api/v1/Log/PlayLog", params).then((res) => {
        console.log(res);
      });
    },
    requestLike() {
      var that = this;
      let v = this.video_info.Videos[this.playIndex];
      if (v.IsLiked) {
        let params = {
          ProductId: 3,
          VideoName: v.VideoTitle,
          CatalogId: that.cateId,
          ImageUrl: v.VideoImage,
          UserId: common.userBase ? common.userBase.UserId : 0,
          CourseId: that.Id,
          VideoId: v.Id,
          OperateType: "like",
          ComId: common.userBase ? common.userBase.ComId : 0,
        };
        this.postRequest("api/v1/UserOperate/UserCancelOperate", params).then(
          (res) => {
            if (res.IsSuccess) {
              v.IsLiked = false;
              v.LikeCount = v.LikeCount - 1;
            }
          }
        );
      } else {
        let params = {
          ProductId: 3,
          VideoName: v.VideoTitle,
          CatalogId: that.cateId,
          ImageUrl: v.VideoImage,
          UserId: common.userBase ? common.userBase.UserId : 0,
          CourseId: that.Id,
          VideoId: v.Id,
          OperateType: "like",
          ComId: common.userBase ? common.userBase.ComId : 0,
        };
        this.postRequest("api/v1/UserOperate/UserOperate", params).then(
          (res) => {
            if (res.IsSuccess) {
              v.IsLiked = true;
              v.LikeCount = v.LikeCount + 1;
            }
          }
        );
      }
    },
    playVideo(index) {
      // this.addPlayLog();
      // this.playIndex = index;
      // this.playUrl = this.video_info.Videos[index].VideoUrl;

      if (index === this.playIndex) {
        return;
      } else {
        this.addPlayLog();
        const that = this;
        this.$router.replace({
          name: "video",
          params: {
            cateId: that.cateId,
            Id: that.video_info.Id,
            videoId: that.video_info.Videos[index].Id,
          },
        });
      }
    },
    request(data) {
      var that = this;
      let params = {
        UserId: data.UserId,
        ComId: data.ComId,
        CourseId: this.Id,
        CatalogId: this.cateId
        // secret: data.secret,
      };
      this.getRequest("api/v1/Course/GetCourseVideos", params).then(
        (result) => {
          if (result.IsSuccess) {
            that.requestCatalogData();
            that.video_info = result.Data;
            if (result.Data.Videos.length > 8) {
              that.showShadow = true;
            }
            let index = 0;
            if (that.videoId != 0) {
              for (let i = 0; i < result.Data.Videos.length; i++) {
                if (result.Data.Videos[i].Id == that.videoId) {
                  that.playIndex = i;
                  that.playUrl = result.Data.Videos[i].VideoUrl || 0;
                  break;
                }
              }
            } else {
              that.playIndex = 0;
              that.playUrl = result.Data.Videos[0].VideoUrl || 0;
            }
            document.title = result.Data.CourseTitle;
          } else {
          }
          this.requestQRImage();
        }
      );
    },
    requestCatalogData() {
      const that = this;
      this.getRequestVisit(`api/v1/Catalogs/${this.cateId}`, {}).then(
        (result) => {
          that.CatalogData = result.catalogData;
        }
      );
    },
    requestShare() {
      var that = this;
      let v = this.video_info.Videos[this.playIndex];
      let params = {
        ProductId: 3,
        VideoName: v.VideoTitle,
        CatalogId: that.cateId,
        ImageUrl: v.VideoImage,
        UserId: common.userBase ? common.userBase.UserId : 0,
        CourseId: that.Id,
        VideoId: v.Id,
        OperateType: "share",
        ComId: common.userBase ? common.userBase.ComId : 0,
      };
      this.postRequest("api/v1/UserOperate/UserOperate", params);
    },
    requestQRImage() {
      let video = this.video_info.Videos[this.playIndex];
      return `https://kids.wap.bjadks.com/#/pages/player?courseId=${this.Id}&videoId=${video.Id}&catalogId=${this.cateId}`
    },
    requestRelated() {
      var that = this;
      this.getRequest("api/v1/Course/RelateRecommend", {
        CatalogId: this.cateId,
        CourseId: this.Id,
      }).then((res) => {
        if (res.IsSuccess) {
          let ary = res.Data;
          if (ary.length > 4 && ary.length < 8) {
            that.rec_list = res.Data.slice(0, 4);
          } else {
            that.rec_list = res.Data;
          }
        }
      });
    },
    shareToQQZone() {
      //自定义内容
      this.requestShare();
      const share = {
        title: "少儿多媒体图书馆",
        desc: "描述",
        image_url: ["https://pic.downk.cc/item/5e7b64fd504f4bcb040fae8f.jpg"],
        share_url: "https://www.jianshu.com/p/4b634f20be2e",
      };
      let image_urls = share.image_url.map(function (image) {
        return encodeURIComponent(image);
      });
      //跳转地址
      window.open(
        "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&pics=" +
          image_urls.join("|") +
          "&summary=" +
          share.desc
      );
    },
    shareWechat() {
      if (!this.showShare) {
        this.requestShare();
        this.showShare = true
        setTimeout(() => {
          new QRCode(this.$refs.qrCodeUrl, {
            text: this.requestQRImage(), // 需要转换为二维码的内容
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          })
        }, 500);
      }
    },
    closeShare() {
      this.showShare = false;
    },
  },
};
</script>

<style scoped>
.top-bg {
  background: url("../../assets/video/icon-video-bg.jpg");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
}

.content {
  padding-bottom: 0.5rem;
}

.wrap {
  padding: 0.3rem 0.3rem 0;
  border-radius: 0.16rem;
  min-height: 12rem;
  margin-top: 0.3rem;
  z-index: 2;
  background-color: #ffffff;
}

.wrap .vd {
  /* height: 9.11rem; */
  background-color: #262930;
  border-radius: 0.16rem;
  margin-top: 0.2rem;
}

.wrap .vd .vd-tp {
  height: 5.85rem;
}

.wrap .vd .vd-tp .video {
  width: 10.15rem;
  border-top-left-radius: 0.16rem;
  background-color: #000;
}

.wrap .vd .vd-tp embed {
  width: 10.15rem;
  height: 100%;
  background-color: #000;
}

.wrap .vd .vd-tp .menu-item-wrap {
  overflow: scroll;
  margin-top: 0.24rem;
}
.wrap .vd .vd-tp .menu-item-wrap::-webkit-scrollbar {
  display: none;
}
.wrap .vd .vd-tp .menu {
  flex: 1;
  border-top-right-radius: 0.16rem;
  padding: 0.2rem 0.2rem 0;
  position: relative;
}

.wrap .vd .vd-tp .menu .menu-item {
  height: 0.6rem;
  border-bottom: 0.01rem solid rgba(89, 89, 89, 0.5);
  line-height: 0.6rem;
}

.wrap .vd .vd-tp .menu .menu-item .tit {
  line-height: 0.6rem;
}

.wrap .vd .vd-tp .menu .menu-item .date {
  line-height: 0.6rem;
}

.wrap .vd .vd-bottom {
  padding-left: 0.2rem;
  padding-right: 3.24rem;
  /* height: 3.26rem; */
}

.wrap .vd-bottom .share {
  height: 0.9rem;
  border-bottom: 0.01rem solid #3c3c3c;
  position: relative;
}

.wrap .vd-bottom .share .btn {
  width: 1.12rem;
  height: 0.46rem;
  border-radius: 0.23rem;
}

.wrap .vd-bottom .share .btn .icon {
  width: 0.26rem;
  margin-right: 0.1rem;
}

.wrap .vd-bottom .share .img {
  margin-right: 0.2rem;
}

.wx {
  width: 0.38rem;
  height: 0.32rem;
}

.sina {
  width: 0.43rem;
  height: 0.34rem;
}

.qr {
  width: 0.28rem;
  height: 0.28rem;
}

.qq {
  width: 0.33rem;
  height: 0.33rem;
}

.wrap .vd-bottom .video_info .t {
  margin: 0.2rem 0;
  color: #fff;
}

.wrap .vd-bottom .video_info .des {
  margin-bottom: 0.4rem;
  line-height: 0.36rem;
  min-height: 1.12rem;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
}

.bottom-bg {
  margin-top: -3.5rem;
  background: url("../../assets/video/icon-video-bottombg.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: bottom;
  width: 100%;
  height: 5.97rem;
  /* z-index: 1; */
}

.shadow {
  height: 0.6rem;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 100;
  font-size: 0.2rem;
  text-align: center;
  line-height: 0.6rem;
  color: white;
  background: linear-gradient(
    rgba(38, 41, 48, 0),
    rgba(38, 41, 48, 0.5) 40%,
    rgba(38, 41, 48, 0.8)
  );
}

@keyframes rowup {
  0% {
    margin-top: 0;
  }

  25% {
    margin-top: -0.1rem;
  }

  75% {
    margin-top: 0.2rem;
  }

  100% {
    margin-top: 0;
  }
}

.animation {
  animation: 1s rowup linear infinite;
  display: inline-block;
  transform: rotate(180deg);
}

.rec .t {
  margin-top: 0.35rem;
}

.t .line {
  width: 4.5rem;
  height: 0.01rem;
  border-bottom: 0.01rem dashed #607167;
}

.t img {
  width: 0.66rem;
  height: 0.65rem;
  margin-left: 0.67rem;
  margin-right: 0.24rem;
}

.t span {
  font-size: 0.48rem;
}

.t .last {
  margin-right: 0.67rem;
}

.rec-list {
  margin-top: 0.2rem;
}

.item {
  margin-right: calc((100% - 12.6rem) / 3);
  margin-bottom: 0.48rem;
  background-color: #fff;
}

.item:nth-child(4n) {
  margin-right: 0;
}

.dplayer-controller {
  font-size: 0;
}

.share-img {
  padding: 0.1rem 0.2rem;
  position: absolute;
  top: 0.8rem;
  left: 0rem;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.share-img .qr-code {
  width: 200px;
  height: 200px;
}

.t-line-1 {
  max-height: 0.32rem;
  line-height: 0.32rem;
  overflow: hidden;
}

.play-icon {
  width: 0.07rem;
  height: 0.1rem;
  margin-right: 0.1rem;
}
.list:hover {
  color: #23cebc;
}

.vd-tp .video {
  padding-top: 0.1rem;
  padding-left: 0.1rem;
}
.dplayer-notice {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/view/video/video.vue